import React, { useState, useEffect, useCallback, useMemo } from "react";
import './pagination.scss';
import { Pagination } from 'react-bootstrap';
import { SelectBox } from 'devextreme-react';

interface IPaginationProps {
    totalRecord: number;
    currentPageNo: number;
    goToPreviousPage: (pageNumber: number) => void;
    goToNextPage: (pageNumber: number) => void;
    changePageSize: (pageSize: number) => void;
    totalPage: number;
    isLessthanTotalElement: boolean;
    dataLength: number;
}

function DynamicPagination(props: IPaginationProps) {
    const [prePage, setPrePage] = useState();
    const [nextPage, setNextPage] = useState();
    const [pageSize, setPageSize] = useState();
    const [pageSizeList, setPageSizeList] = useState<any>([{ "name": 10 }, { "name": 25 }, { "name": 50 }, { "name": 100 }]);
    const defaultPageSize = 10;
    const pageSizeLst = useMemo(() => [{ "name": 10 }, { "name": 25 }, { "name": 50 }, { "name": 100 }], []);
    const { changePageSize, goToNextPage, goToPreviousPage } = props;
    const noOfPageDropdown = useCallback(() => {
        if (props.totalRecord <= 10) setPageSizeList(pageSizeLst.slice(0, 1))
        else if (props.totalRecord > 10 && props.totalRecord <= 25) setPageSizeList(pageSizeLst.slice(0, 2))
        else if (props.totalRecord > 25 && props.totalRecord <= 50) setPageSizeList(pageSizeLst.slice(0, 3))
        else setPageSizeList(pageSizeLst.slice(0, 4))

    }, [pageSizeLst, props.totalRecord])

    useEffect(() => {
        noOfPageDropdown()
    }, [noOfPageDropdown])

    const goToPreviousPageHandler = useCallback((page: any) => {
        setPrePage(page);
        goToPreviousPage(page);
    }, [goToPreviousPage]);

    const goToNextPageHandler = useCallback((page: any) => {
        setNextPage(page);
        goToNextPage(page);
    }, [goToNextPage]);

    useEffect(() => {
        if (prePage) {
            goToPreviousPageHandler(prePage);
        }
    }, [goToPreviousPageHandler, prePage]);

    useEffect(() => {
        if (nextPage) {
            goToNextPageHandler(nextPage);
        }
    }, [goToNextPageHandler, nextPage]);

    useEffect(() => {
        if (pageSize) {
            changePageSize(pageSize);
        }
    }, [changePageSize, pageSize]);

    const handleChangePageSize = (value: any) => {
        setPageSize(value);
    }

    const safeTotalPage = Number.isFinite(props.totalPage as number) && (props.totalPage as number) > 0
        ? props.totalPage
        : 1;
    const safeTotalRecord =
        typeof props.totalRecord === 'number' && props.totalRecord >= 0
            ? props.totalRecord
            : (typeof props.dataLength === 'number' && props.dataLength >= 0
                ? props.dataLength
                : 0);

    return (
        <div className={`pagination-cover dx-theme-background-color`} >
            <div className="total-result">
                <div className="total-size">
                    {/* <p className="dx-theme-text-color">Showing {props.currentPageNo} of {safeTotalPage} pages ({safeTotalRecord} records)</p> */}
                    <p>Showing {props.currentPageNo} of {safeTotalPage} Pages | ({safeTotalRecord} Records)</p>
                    <div className="filter-box pagination-pageSize">
                        <div className='option'>
                            <SelectBox
                                stylingMode='outlined'
                                items={pageSizeList}
                                id='outlined-select-currency-native'
                                displayExpr='name'
                                valueExpr='name'
                                // label='page size'
                                value={pageSize ? pageSize : defaultPageSize}
                                defaultValue={defaultPageSize}
                                onValueChange={(event: any) => { handleChangePageSize(event) }}
                                height={"35px"}
                            />
                        </div>
                    </div>
                </div>
                <Pagination>
                    <Pagination.Item
                        onClick={() => {
                            if (props.currentPageNo && props.currentPageNo > 1)
                                goToPreviousPageHandler(1)
                        }}
                        disabled={props.currentPageNo === 1}

                    >
                        First Page
                    </Pagination.Item>

                    <Pagination.Prev
                        onClick={() => {
                            if (props.currentPageNo !== 1) {
                                const page = props.currentPageNo ? props.currentPageNo - 1 : 1;
                                goToPreviousPageHandler(page)
                            } else {
                                goToPreviousPageHandler(props.currentPageNo)
                            }
                        }}
                        disabled={props.currentPageNo === 1}
                    />

                    <Pagination.Item disabled>{props.currentPageNo}</Pagination.Item>

                    <Pagination.Next
                        onClick={() => {
                            if ((!props.isLessthanTotalElement && props.currentPageNo && safeTotalPage) && (props.currentPageNo < safeTotalPage)) {
                                const page = props.currentPageNo + 1;
                                goToNextPageHandler(page)
                            }
                            else {
                                goToNextPageHandler(props.currentPageNo);
                            }
                        }}
                        disabled={(props.currentPageNo === safeTotalPage) || (props.dataLength === 0)}
                    />
                    <Pagination.Item
                        onClick={() => {
                            if ((props.currentPageNo && safeTotalPage) && props.currentPageNo < safeTotalPage)
                                goToNextPageHandler(safeTotalPage)
                        }}
                        disabled={(props.currentPageNo === safeTotalPage) || (props.dataLength === 0)}
                    >
                        Last Page
                    </Pagination.Item>
                </Pagination>
            </div>

        </div>
    );
}

export default React.memo(DynamicPagination);